import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Paper,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tooltip,
} from "@material-ui/core";

import InfoIcon from "@material-ui/icons/Info";

import ModalAttributionTranche from "../attribution/modal/ModalAttributionTranche.js";
import AppContext from "../../components/appContext.js";

import { Alert, AlertTitle, Autocomplete } from "@material-ui/lab";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import DescriptionIcon from "@material-ui/icons/Description";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import useStyles from "./tableauDesAttributionsStyles.js";
import { useSelector } from "react-redux";
import MultipleSelect from "./MultipleSelect";
import rest from "../../rest";
import moment from "moment";

function TableauDesAttributionsv2() {
  console.warn = () => {};
  const classes = useStyles();

  const manifInfos = useSelector((state) => state.manif.manifInfos);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [search, setSearch] = useState("");
  const [userChangedTranche, setUserChangedTranche] = useState(false);
  const myContext = useContext(AppContext);
  const openSidebar = myContext.openSidebar;

  const [modalOpen, setModalOpen] = useState(false);

  const [tranchesAffichage, setTranchesAffichage] = useState([]);
  const [allTranches, setAllTranches] = useState([]);

  const [reloadAffichage, setReloadAffichage] = useState(false);
  const [changedState, setChangedState] = useState(false);
  const [selectedTranches, setSelectedTranches] = useState([]);

  const [selectedUser, setSelectedUser] = useState({});
  const [benevoles, setBenevoles] = useState({});
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [statsBenevoles, setStatsBenevoles] = useState({
    totalBenevoles: 0,
    totalBenevolesValides: 0,
  });

  // Les options de trie (defaut: alphabetique)
  const [trie, setTrie] = useState("alphabetique");

  const [triCroissant, setTriCroissant] = useState(true);

  // Les options de recherche
  const [payLoad, setPayLoad] = useState({
    idActivite: 0,
    jour: "tous",
    debutTranche: "",
    finTranche: "",
  });

  // Les options des filtres
  const [filtersOptions, setFiltersOptions] = useState({
    aFinaliser: false,
    aTraiter: false,
    dispoRestantes: false,
  });

  const [dataReady, setDataReady] = useState(false);

  // Option tri dans le select
  let sortOptions = [];
  if (manifInfos.Ref === "chi" || manifInfos.Ref === "jivahillstables") {
    sortOptions = [
      {
        key: "experience",
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            Expériences
            <Tooltip
              title="Tri effectué selon l'expérience du bénévole pour la sous-activité choisie, puis selon son expérience générale toutes sous-activités confondues."
              arrow
            >
              <InfoIcon />
            </Tooltip>
          </div>
        ),
      },
      { key: "dispos", label: "Disponibilités" },
      { key: "statut", label: "Statut" },
      { key: "date", label: "Dernière inscription" },
      { key: "alphabetique", label: "Ordre alphabétique" },
    ];
  } else {
    sortOptions = [
      {
        key: "experience",
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            Expériences
            <Tooltip
              title="Tri effectué selon l'expérience du bénévole pour la sous-activité choisie, puis selon son expérience générale toutes sous-activités confondues."
              arrow
            >
              <InfoIcon
                style={{
                  fontSize: "small",
                  marginLeft: "4px",
                  color: "rgba(0, 0, 0, 0.54)",
                }}
              />
            </Tooltip>
          </div>
        ),
      },
      { key: "date", label: "Date d'inscription" },
      { key: "alphabetique", label: "Ordre alphabétique" },
    ];
  }

  // Les options pour les selects
  const [options, setOptions] = useState({
    jours: [],
    activities: [],
    tranchesDebut: [],
    tranchesFin: [],
  });

  const handleSelectChange = (event) => {
    setTrie(event.target.value);
  };

  const handleOrderChange = () => {
    setTriCroissant((prev) => !prev);
  };

  // Recup les bénévoles par activité
  useEffect(() => {
    if (payLoad.idActivite === 0) return;
    setLoading(true);
    setDataReady(false);
    rest
      .post("/tableauDesAttributions/getBenevolesByActivity.json", {
        idActivite: payLoad.idActivite,
      })
      .then((response) => {
        setFilteredUsers([]);
        setBenevoles(response.data.benevoles);
        setStatsBenevoles((prev) => ({
          ...prev,
          totalBenevolesValides: response.data.nbBenevolesValidesEdition,
        }));
        setLoading(false);
        setDataReady(true);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        setLoading(false);
        setDataReady(true);
      });
  }, [payLoad.idActivite, changedState]);

  // Recup toutes les activités au premier chargement de la page (pour le select) :
  useEffect(() => {
    setLoading(true);
    rest
      .post("/tableauDesAttributions/distinctActivite.json", {})
      .then((response) => {
        setLoading(false);
        if (response.data.length > 0) {
          // On set les activités
          setOptions((prev) => ({
            ...prev,
            activities: response.data,
          }));
          // On set l'id de l'activité par défaut
          setPayLoad((prev) => ({
            ...prev,
            idActivite: response.data[0].ID,
          }));
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  // Recup les parametres pour les tranches
  useEffect(() => {
    if (payLoad.idActivite === 0) return;

    setLoading(true);
    rest
      .post("/tableauDesAttributions/tranchesActivite.json", {
        idActivite: payLoad.idActivite,
        jours: payLoad.jour,
        du: payLoad.debutTranche ? payLoad.debutTranche : "",
        au: payLoad.finTranche ? payLoad.finTranche : "",
      })
      .then((response) => {
        const tranchesDebut = response.data.tranchesDebut;
        const tranchesFin = response.data.tranchesFin;

        setOptions((prev) => ({
          ...prev,
          jours: response.data.dates,
          tranchesDebut,
          tranchesFin,
        }));

        setTranchesAffichage(response.data.tranches);
        setAllTranches(response.data.allTranches);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        setLoading(false);
      });
  }, [
    payLoad.idActivite,
    payLoad.jour,
    payLoad.debutTranche,
    payLoad.finTranche,
  ]);

  // Recup les users en fonction de l'activité + l'état
  useEffect(() => {
    if (benevoles.length > 0) {
      let combinedFilteredUsers = [];

      // Retirer si aucunes tranches ne sont cochées
      combinedFilteredUsers = removeUsersWithoutTranches(
        benevoles,
        tranchesAffichage,
        filtersOptions,
        payLoad
      );

      // Retirer les bénévoles à finaliser (pré-valider) si l'option n'est pas cochée
      if (!filtersOptions.aFinaliser) {
        combinedFilteredUsers = combinedFilteredUsers.filter(
          (b) => b.statut !== "preValider"
        );
      }

      // Retirer les bénévoles à traiter (wish) si l'option n'est pas cochée
      if (!filtersOptions.aTraiter) {
        combinedFilteredUsers = combinedFilteredUsers.filter(
          (b) => b.statut !== "wish"
        );
      }

      /*   // Retirer les bénévoles avec des dispos restantes et aucune tranche validée si l'option n'est pas cochée
      if (!filtersOptions.dispoRestantes) {
        combinedFilteredUsers = combinedFilteredUsers.filter(
          (b) =>
            (b.statut === "preValider" ||
              b.statut === "valide" ||
              b.statut === "wish") &&
            b.tempo.every((tranche) => tranche.parentId !== payLoad.idActivite)
        );
      } */

      // Appliquer la recherche
      const filtered = combinedFilteredUsers.filter(
        (b) =>
          b.Name.toLowerCase().includes(search) ||
          b.Firstname.toLowerCase().includes(search)
      );

      // Appliquer le tri
      let sorted = [];

      switch (trie) {
        case "dispos":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => {
              const aCount =
                a?.wish?.tranches.filter(
                  (t) => t.parentId === payLoad.idActivite
                ).length || 0;
              const bCount =
                b?.wish?.tranches.filter(
                  (t) => t.parentId === payLoad.idActivite
                ).length || 0;
              const lengthDiff = aCount - bCount;
              return lengthDiff !== 0
                ? lengthDiff
                : a.Name.localeCompare(b.Name);
            });
          } else {
            sorted = filtered.sort((a, b) => {
              const aCount =
                a?.wish?.tranches.filter(
                  (t) => t.parentId === payLoad.idActivite
                ).length || 0;
              const bCount =
                b?.wish?.tranches.filter(
                  (t) => t.parentId === payLoad.idActivite
                ).length || 0;
              const lengthDiff = bCount - aCount;
              return lengthDiff !== 0
                ? lengthDiff
                : b.Name.localeCompare(a.Name);
            });
          }
          break;
        case "experience":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => {
              const totalActA =
                a.totalHeureParActivité[payLoad.idActivite] || 0;
              const totalActB =
                b.totalHeureParActivité[payLoad.idActivite] || 0;
              const totalHeureDiff =
                totalActA || totalActB
                  ? totalActA - totalActB
                  : a.totalHeure - b.totalHeure;
              return totalHeureDiff !== 0
                ? totalHeureDiff
                : a.Name.localeCompare(b.Name);
            });
          } else {
            sorted = filtered.sort((a, b) => {
              const totalActA =
                a.totalHeureParActivité[payLoad.idActivite] || 0;
              const totalActB =
                b.totalHeureParActivité[payLoad.idActivite] || 0;
              const totalHeureDiff =
                totalActA || totalActB
                  ? totalActB - totalActA
                  : b.totalHeure - a.totalHeure;
              return totalHeureDiff !== 0
                ? totalHeureDiff
                : b.Name.localeCompare(a.Name);
            });
          }
          break;
        case "alphabetique":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => a.Name.localeCompare(b.Name));
          } else {
            sorted = filtered.sort((a, b) => b.Name.localeCompare(a.Name));
          }
          break;
        case "statut":
          sorted = filtered.sort(compareByStatusAndName);
          break;
        case "date":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => {
              const dateDiff =
                new Date(a.lastInscription) - new Date(b.lastInscription);
              return dateDiff !== 0 ? dateDiff : a.Name.localeCompare(b.Name);
            });
          } else {
            sorted = filtered.sort((a, b) => {
              const dateDiff =
                new Date(b.lastInscription) - new Date(a.lastInscription);
              return dateDiff !== 0 ? dateDiff : b.Name.localeCompare(a.Name);
            });
          }
          break;
        default:
          sorted = filtered;
      }

      setFilteredUsers(sorted);
      setReloadAffichage((prev) => !prev);
    }
    // eslint-disable-next-line
  }, [
    benevoles,
    filtersOptions,
    tranchesAffichage,
    search,
    trie,
    triCroissant,
    payLoad,
  ]);

  // remplacer les cacractères spéciaux par underscore
  function replaceSpecialCharacters(input) {
    return input.replace(/[ ,:.-/]+/g, "_");
  }

  // Si on change de jour alors on change les tranches de début et de fin
  useEffect(() => {
    if (options.tranchesDebut.length > 0 && options.tranchesFin.length > 0) {
      setPayLoad((prev) => ({
        ...prev,
        debutTranche: !userChangedTranche
          ? options.tranchesDebut[0]
          : prev.debutTranche,
        finTranche: !userChangedTranche
          ? options.tranchesFin[options.tranchesFin.length - 1]
          : prev.finTranche,
      }));
    }
    // eslint-disable-next-line
  }, [options.tranchesDebut, options.tranchesFin, payLoad.jour]);

  // Fonction pour exporter les attributions en excel
  const handleExport = async () => {
    let idActivite = payLoad.idActivite;
    let nameActivite = options.activities.find(
      (activity) => activity.ID === idActivite
    ).Nom;
    nameActivite = replaceSpecialCharacters(nameActivite);

    const formData = new FormData();
    formData.append("vIdActivite", idActivite);
    formData.append("vBenevoles", JSON.stringify(benevoles));
    formData.append("aTraiter", filtersOptions.aTraiter);
    formData.append("dispoRestantes", filtersOptions.dispoRestantes);
    formData.append("aFinaliser", filtersOptions.aFinaliser);

    setDownloading(true);
    const response = await fetch("/export/attributions", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      const formattedDate = moment().format("DD.MM.YYYY");
      a.href = url;
      a.download =
        "TableauAttributions_export_" +
        nameActivite +
        "_" +
        formattedDate +
        ".xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setDownloading(false);
    } else {
      console.error("Failed to export attributions");
      setDownloading(false);
    }
  };

  // Fonction pour gérer les changements dans les inputs
  const handleChange = (event, id) => {
    const { value } = event.target;

    const updates = {
      idActivite: () => {
        setPayLoad((prev) => ({
          ...prev,
          idActivite: value,
        }));
      },
      jour: () => {
        setPayLoad((prev) => ({
          ...prev,
          jour: value,
        }));
        setUserChangedTranche(false);
      },
      debutTranche: () => {
        setPayLoad((prev) => ({
          ...prev,
          debutTranche: value,
        }));
        setUserChangedTranche(true);
      },
      finTranche: () => {
        setPayLoad((prev) => ({
          ...prev,
          finTranche: value,
        }));
        setUserChangedTranche(true);
      },
      search: () => {
        setSearch(value.toLowerCase());
      },
    };

    if (updates[id]) {
      updates[id]();
    } else {
      console.log("Unknown error");
    }
  };

  // Fonction pour attribuer une couleur à une tranche (case de la table)
  const getTrancheColor = (statut) => {
    switch (statut) {
      case "Valide":
        return { backgroundColor: "#C6EDC3", content: "" }; // Vert
      case "Wish":
        return { backgroundColor: "#FFC7BA", content: "" }; // Rouge
      case "PreValider":
        return { backgroundColor: "#FFF2CD", content: "" }; // Jaune
      case "Dispo":
        return { backgroundColor: "none", content: "+" }; // Bleu
      default:
        return { backgroundColor: "none", content: "" }; // Blanc par défaut
    }
  };

  // Fonction de comparaison pour le tri par statut (1) puis par nom (2)
  const compareByStatusAndName = (a, b) => {
    const priority = { valide: 3, preValider: 2, wish: 1 };
    const statusA = priority[a.statut] || 0;
    const statusB = priority[b.statut] || 0;

    if (statusA === statusB) {
      return triCroissant
        ? a.Name.localeCompare(b.Name)
        : b.Name.localeCompare(a.Name);
    }

    return triCroissant ? statusA - statusB : statusB - statusA;
  };

  const handleOpenModal = useCallback(() => {
    if (manifInfos.Ref !== "chi") {
      return;
    }
    setModalOpen(true);
  }, [manifInfos.Ref]);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const removeUsersWithoutTranches = (
    users,
    tranchesAffichage,
    filtersOptions,
    payLoad
  ) => {
    return users.filter((benevole) => {
      let hasData = false;
      let hasDataFromOtherActivity = false;

      tranchesAffichage.forEach((tranche) => {
        switch (benevole.statut) {
          case "wish":
            if (
              benevole.wish.tranches &&
              benevole.wish.tranches.some((benevoleTranche) => {
                if (payLoad.jour === "tous") {
                  return (
                    tranche.enfants &&
                    tranche.enfants.includes(benevoleTranche.ID)
                  );
                } else {
                  return benevoleTranche.ID === tranche.ID;
                }
              })
            ) {
              hasData = true;
            }
            break;
          case "preValider":
            if (
              benevole.tempo &&
              benevole.tempo.some((benevoleTranche) => {
                if (benevoleTranche.parentId === payLoad.idActivite) {
                  if (payLoad.jour === "tous") {
                    return (
                      tranche.enfants &&
                      tranche.enfants.includes(benevoleTranche.ID) &&
                      benevoleTranche.parentId === payLoad.idActivite
                    );
                  } else {
                    return (
                      benevoleTranche.ID === tranche.ID &&
                      benevoleTranche.parentId === payLoad.idActivite
                    );
                  }
                }
                return false;
              })
            ) {
              hasData = true;
            } else if (
              filtersOptions.dispoRestantes &&
              benevole.wish.tranches &&
              benevole.wish.tranches.some((benevoleTranche) => {
                if (benevoleTranche.parentId === payLoad.idActivite) {
                  if (payLoad.jour === "tous") {
                    return (
                      tranche.enfants &&
                      tranche.enfants.includes(benevoleTranche.ID)
                    );
                  } else {
                    return benevoleTranche.ID === tranche.ID;
                  }
                }
                return false;
              })
            ) {
              hasData = true;
            }
            hasDataFromOtherActivity = benevole.tempo.some(
              (tranche) => tranche.parentId !== payLoad.idActivite
            );

            hasData = true;
            if (hasDataFromOtherActivity) {
              hasData = false;
            }
            break;
          case "valide":
            if (
              benevole.tempo &&
              benevole.tempo.some((benevoleTranche) => {
                if (payLoad.jour === "tous") {
                  return (
                    tranche.enfants &&
                    tranche.enfants.includes(benevoleTranche.ID) &&
                    benevoleTranche.parentId === payLoad.idActivite
                  );
                } else {
                  return (
                    benevoleTranche.ID === tranche.ID &&
                    benevoleTranche.parentId === payLoad.idActivite
                  );
                }
              })
            ) {
              hasData = true;
            }

            // Vérifie les disponibilités restantes seulement si l'option est activée
            if (
              filtersOptions.dispoRestantes &&
              benevole.wish.tranches &&
              benevole.wish.tranches.some((benevoleTranche) => {
                if (benevoleTranche.parentId === payLoad.idActivite) {
                  if (payLoad.jour === "tous") {
                    return (
                      tranche.enfants &&
                      tranche.enfants.includes(benevoleTranche.ID)
                    );
                  } else {
                    return benevoleTranche.ID === tranche.ID;
                  }
                }
                return false;
              })
            ) {
              hasData = true;
            }

            hasDataFromOtherActivity = benevole.tempo.some(
              (tranche) => tranche.parentId !== payLoad.idActivite
            );

            if (!filtersOptions.dispoRestantes && hasDataFromOtherActivity) {
              hasData = false;
            }
            break;
          default:
            hasData = false;
        }
      });

      return hasData;
    });
  };

  // Fonction pour récupérer le nombre maximum de bénévoles par tranche
  const getNbTotalBenevoleJour = (tranchesAffichage) => {
    if (!tranchesAffichage || tranchesAffichage.length === 0) {
      return null; // ou une valeur par défaut
    }

    return tranchesAffichage.reduce((totalBenevolesTranche, tranche) => {
      return Math.max(totalBenevolesTranche, tranche.totalBenevolesTranche);
    }, tranchesAffichage[0].totalBenevolesTranche);
  };

  // Fonction pour calculer le total des heures pour l'édition
  const calculateTotalHoursEdition = (
    benevoles,
    id,
    jour = false,
    tranchesAffichage = []
  ) => {
    const benevole = benevoles.find((b) => b.ID === id);

    if (!benevole || benevole.statut === "wish") {
      return " - ";
    }

    let totalMinutes = 0;

    if (jour) {
      tranchesAffichage.forEach((tranche) => {
        const matchingTempo = benevole.tempo.find((t) => t.ID === tranche.ID);
        if (matchingTempo) {
          totalMinutes +=
            (matchingTempo.HeureFin - matchingTempo.HeureDebut) / 60;
        }
      });
    } else {
      totalMinutes = benevole.tempo.reduce((total, tranche) => {
        return total + (tranche.HeureFin - tranche.HeureDebut) / 60;
      }, 0);
    }

    // Arrondir les minutes à la dizaine la plus proche
    // const roundedMinutes = Math.round(totalMinutes / 10) * 10;  LR , ne plus arrondir

    // Convertir les minutes en heures et minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Formater en hh:mm
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${formattedHours}h${formattedMinutes}`;
  };

  return (
    <>
      <LoadingIndicator open={loading || !dataReady} />

      {modalOpen && selectedUser && (
        <ModalAttributionTranche
          setReload={setChangedState}
          user={selectedUser}
          open={modalOpen}
          handleClose={handleCloseModal}
          selectedActivity={{
            name: options.activities.find(
              (activity) => activity.ID === payLoad.idActivite
            ).Nom,
            id: payLoad.idActivite,
          }}
          selectedTranches={selectedTranches}
          setSelectedTranches={setSelectedTranches}
          activeStep={{
            label: "À traiter",
            colorClass: "step-button-red",
            type: selectedUser.statut,
          }}
        />
      )}
      {dataReady && (
        <Paper
          style={{
            marginTop: 10,
            padding: 20,
            maxWidth: !openSidebar
              ? "calc(100vw - 0px)"
              : "calc(100vw - 300px)",
          }}
          elevation={5}
        >
          {/*  Select + recherche + checkbox */}
          <Grid container style={{ marginBottom: 16 }} spacing={2}>
            {/* LIGNE 1 */}
            <Grid container item xs={6}>
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={
                    downloading ? (
                      <CircularProgress
                        size={18}
                        className={classes.circularProgress}
                      />
                    ) : (
                      <DescriptionIcon size={24} />
                    )
                  }
                  onClick={handleExport}
                  disabled={filteredUsers.length === 0 ? true : false}
                >
                  Exporter
                </Button>
              </Grid>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={6} style={{ paddingRight: 16 }}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel>Jour</InputLabel>
                  <Select
                    // value={payLoad.jour ? payLoad.jour : "Tous"}
                    // if payLoad.jour is undefined or not in the array options.jours, set it to "Tous"
                    value={
                      options.jours.includes(payLoad.jour)
                        ? payLoad.jour
                        : "tous"
                    }
                    onChange={(e) => handleChange(e, "jour")}
                    label="Jour"
                  >
                    <MenuItem value="tous">
                      <em>Tous</em>
                    </MenuItem>
                    {options.jours.map((jour) => (
                      <MenuItem key={jour} value={jour}>
                        {jour}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={options.activities}
                  getOptionLabel={(option) => option.Nom}
                  value={
                    options.activities.find(
                      (activity) => activity.ID === payLoad.idActivite
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange(
                      { target: { value: newValue ? newValue.ID : 0 } },
                      "idActivite"
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={manifInfos.DenominationSousAct}
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
            </Grid>
            {/* LIGNE 2 */}
            <Grid container item xs={6}>
              <Grid item xs={6}>
                <></>
              </Grid>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={6} style={{ paddingRight: 16 }}>
                <FormControl variant="outlined" size="small" fullWidth>
                  {payLoad.jour === "tous" ? (
                    <InputLabel>Du</InputLabel>
                  ) : (
                    <InputLabel>De</InputLabel>
                  )}
                  <Select
                    //value={payLoad.debutTranche ? payLoad.debutTranche : ""}
                    value={
                      payLoad.jours === "tous"
                        ? options.jours.includes(payLoad.debutTranche)
                          ? payLoad.debutTranche
                          : options.jours[0]
                        : payLoad.debutTranche
                    }
                    onChange={(e) => handleChange(e, "debutTranche")}
                    label={payLoad.jour === "tous" ? "Du" : "De"}
                  >
                    {options.tranchesDebut.map((tranche, index) => (
                      <MenuItem key={index} value={tranche}>
                        {tranche}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl variant="outlined" size="small" fullWidth>
                  {payLoad.jour === "tous" ? (
                    <InputLabel>Au</InputLabel>
                  ) : (
                    <InputLabel>A</InputLabel>
                  )}
                  <Select
                    //value={payLoad.finTranche ? payLoad.finTranche : ""}
                    value={
                      payLoad.jours === "tous"
                        ? options.jours.includes(payLoad.finTranche)
                          ? payLoad.finTranche
                          : options.jours[options.jours.length - 1]
                        : payLoad.finTranche
                    }
                    onChange={(e) => handleChange(e, "finTranche")}
                    label={payLoad.jour === "tous" ? "Au" : "A"}
                  >
                    {options.tranchesFin.map((tranche, index) => (
                      <MenuItem key={index} value={tranche}>
                        {tranche}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {/* LIGNE 3 */}
            <Grid container item xs={6}>
              <Grid item xs={4}>
                <TextField
                  label="Recherche"
                  variant="outlined"
                  value={search}
                  onChange={(e) => handleChange(e, "search")}
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={6} style={{ paddingRight: 16 }}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel>Tri</InputLabel>
                  <Select
                    value={trie}
                    onChange={handleSelectChange}
                    input={
                      <OutlinedInput
                        label="Tri"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton onClick={handleOrderChange}>
                              {triCroissant ? (
                                <Tooltip
                                  title="Trier par ordre croissant"
                                  arrow
                                >
                                  <ArrowUpwardIcon />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title="Trier par ordre décroissant"
                                  arrow
                                >
                                  <ArrowDownwardIcon />
                                </Tooltip>
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    }
                  >
                    {sortOptions.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                {" "}
                {manifInfos.Ref === "chi" ||
                manifInfos.Ref === "jivahillstables" ? (
                  <MultipleSelect
                    filtersOptions={filtersOptions}
                    setFiltersOptions={setFiltersOptions}
                  />
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>

          {filteredUsers.length === 0 && dataReady && (
            <Alert severity="info">
              <AlertTitle>Aucun bénévole trouvé</AlertTitle>
              Aucun bénévole ne correspond à la sélection actuelle.
            </Alert>
          )}

          {filteredUsers.length > 0 && (
            <Paper elevation={3} component={Paper} key={reloadAffichage}>
              <Grid item xs={12}>
                <TableContainer component={Paper} key={reloadAffichage}>
                  <Table aria-label="customized table">
                    {/*  HEADER de la table */}
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableHeader}>
                          Nom
                        </TableCell>
                        <TableCell className={classes.tableHeader}>
                          Prénom
                        </TableCell>

                        {tranchesAffichage.map((tranche, index) => (
                          <TableCell
                            style={{
                              whiteSpace: "nowrap",
                              maxWidth: 65,
                              padding: "5px",
                            }}
                            className={
                              tranchesAffichage.length > 10
                                ? classes.tableHeaderVertical
                                : classes.tableHeader
                            }
                            key={index}
                          >
                            {tranchesAffichage.length > 10 ? (
                              <div className={classes.rotatedHeader}>
                                {tranche.nomTranche}
                              </div>
                            ) : (
                              tranche.nomTranche
                            )}
                          </TableCell>
                        ))}

                        {payLoad.jour !== "tous" && (
                          <TableCell
                            className={classes.tableHeader}
                            style={{ minWidth: 150 }}
                          >
                            Nombre total d'heures pour la journée <br />
                            <span className={classes.italicText}>
                              *toutes&nbsp;activités
                            </span>
                          </TableCell>
                        )}
                        <TableCell
                          className={classes.tableHeader}
                          style={{ minWidth: 150 }}
                        >
                          Nombre total d'heures pour l'édition <br />
                          <span className={classes.italicText}>
                            *toutes&nbsp;activités
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {/*  Contenu de la table */}
                    <TableBody>
                      {filteredUsers.map((benevole, index) => (
                        <TableRow key={index} className={classes.tableRow}>
                          <TableCell
                            className={classes.tableCell}
                            onClick={() => {
                              setSelectedUser(benevole);
                              handleOpenModal();
                            }}
                          >
                            {benevole.Name}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            onClick={() => {
                              setSelectedUser(benevole);
                              handleOpenModal();
                            }}
                          >
                            {benevole.Firstname}
                          </TableCell>

                          {tranchesAffichage.map((tranche, idx) => {
                            let cellContent = "";
                            let cellStyle = {};

                            switch (benevole.statut) {
                              case "wish":
                                if (
                                  benevole.wish.tranches &&
                                  benevole.wish.tranches.some(
                                    (benevoleTranche) => {
                                      if (payLoad.jour === "tous") {
                                        return (
                                          tranche.enfants &&
                                          tranche.enfants.includes(
                                            benevoleTranche.ID
                                          )
                                        );
                                      } else {
                                        return (
                                          benevoleTranche.ID === tranche.ID
                                        );
                                      }
                                    }
                                  )
                                ) {
                                  const { backgroundColor, content } =
                                    getTrancheColor("Wish");
                                  cellStyle = { backgroundColor };
                                  cellContent = content;
                                }
                                break;
                              case "preValider":
                                if (
                                  benevole.tempo &&
                                  benevole.tempo.some((benevoleTranche) => {
                                    if (payLoad.jour === "tous") {
                                      return (
                                        tranche.enfants &&
                                        tranche.enfants.includes(
                                          benevoleTranche.ID
                                        )
                                      );
                                    } else {
                                      return benevoleTranche.ID === tranche.ID;
                                    }
                                  })
                                ) {
                                  const { backgroundColor, content } =
                                    getTrancheColor("PreValider");
                                  cellStyle = { backgroundColor };
                                  cellContent = content;
                                } else if (
                                  filtersOptions.dispoRestantes &&
                                  benevole.wish.tranches &&
                                  benevole.wish.tranches.some(
                                    (benevoleTranche) => {
                                      if (payLoad.jour === "tous") {
                                        return (
                                          tranche.enfants &&
                                          tranche.enfants.includes(
                                            benevoleTranche.ID
                                          )
                                        );
                                      } else {
                                        return (
                                          benevoleTranche.ID === tranche.ID
                                        );
                                      }
                                    }
                                  )
                                ) {
                                  const { backgroundColor, content } =
                                    getTrancheColor("Dispo");
                                  cellStyle = { backgroundColor };
                                  cellContent = content;
                                }
                                break;
                              case "valide":
                                if (
                                  benevole.tempo &&
                                  benevole.tempo.some((benevoleTranche) => {
                                    if (payLoad.jour === "tous") {
                                      return (
                                        tranche.enfants &&
                                        tranche.enfants.includes(
                                          benevoleTranche.ID
                                        )
                                      );
                                    } else {
                                      return benevoleTranche.ID === tranche.ID;
                                    }
                                  })
                                ) {
                                  const { backgroundColor, content } =
                                    getTrancheColor("Valide");
                                  cellStyle = { backgroundColor };
                                  cellContent = content;
                                } else if (
                                  filtersOptions.dispoRestantes &&
                                  benevole.wish.tranches &&
                                  benevole.wish.tranches.some(
                                    (benevoleTranche) => {
                                      if (payLoad.jour === "tous") {
                                        return (
                                          tranche.enfants &&
                                          tranche.enfants.includes(
                                            benevoleTranche.ID
                                          )
                                        );
                                      } else {
                                        return (
                                          benevoleTranche.ID === tranche.ID
                                        );
                                      }
                                    }
                                  )
                                ) {
                                  const { backgroundColor, content } =
                                    getTrancheColor("Dispo");
                                  cellStyle = { backgroundColor };
                                  cellContent = content;
                                }
                                break;
                              default:
                                cellContent = "";
                            }

                            return (
                              <TableCell
                                key={idx}
                                className={classes.tableCell}
                                style={cellStyle}
                              >
                                {cellContent}
                              </TableCell>
                            );
                          })}

                          {payLoad.jour !== "" && payLoad.jour !== "tous" && (
                            <TableCell className={classes.tableCell}>
                              {calculateTotalHoursEdition(
                                benevoles,
                                benevole.ID,
                                true,
                                allTranches.map((id) => ({ ID: id }))
                              )}
                            </TableCell>
                          )}
                          <TableCell className={classes.tableCell}>
                            {calculateTotalHoursEdition(
                              benevoles,
                              benevole.ID,
                              false,
                              tranchesAffichage
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                    {payLoad.jour === "tous" ? (
                      <TableFooter>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          >
                            Nombre total de bénévoles{" "}
                            {manifInfos.Ref === "chi" ? "validés" : ""} par jour
                          </TableCell>
                          {tranchesAffichage.map((tranche, index) => (
                            <TableCell
                              key={index}
                              className={classes.tableHeader}
                            >
                              {tranche.totalBenevolesJour}
                            </TableCell>
                          ))}
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          ></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          >
                            Nombre total de bénévoles{" "}
                            {manifInfos.Ref === "chi" ? "validés" : ""} pour
                            l'édition
                          </TableCell>
                          <TableCell
                            colSpan={tranchesAffichage.length}
                            className={classes.tableHeader}
                          >
                            {statsBenevoles.totalBenevolesValides}
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          ></TableCell>
                        </TableRow>
                      </TableFooter>
                    ) : (
                      <TableFooter>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          >
                            Nombre total de bénévoles{" "}
                            {manifInfos.Ref === "chi" ? "validés" : ""} par
                            tranche horaire
                          </TableCell>
                          {tranchesAffichage.map((tranche, index) => (
                            <TableCell
                              key={index}
                              className={classes.tableHeader}
                            >
                              {tranche.totalBenevolesTranche}
                            </TableCell>
                          ))}
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          ></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          >
                            Nombre total de bénévoles{" "}
                            {manifInfos.Ref === "chi" ? "validés" : ""} par jour
                          </TableCell>
                          <TableCell
                            colSpan={tranchesAffichage.length}
                            className={classes.tableHeader}
                          >
                            {getNbTotalBenevoleJour(tranchesAffichage)}
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            className={classes.tableHeader}
                          ></TableCell>
                        </TableRow>
                      </TableFooter>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            </Paper>
          )}
        </Paper>
      )}
    </>
  );
}

export default TableauDesAttributionsv2;
